<ng-container *ngIf="errorMsg; else resultTpl">
  <nz-result
    nzStatus="error"
    nzTitle="Teamcenter gave an error"
    [nzSubTitle]="errorMsg"
  ></nz-result>
</ng-container>

<ng-template #resultTpl>
  <nz-table
    #datasetTable
    [nzData]="data"
    nzShowPagination="false"
    nzSize="small"
    [nzLoading]="loading"
  >
    <thead>
      <tr>
        <th>Name</th>
        <th>Dataset link / type</th>
      </tr>
    </thead>
    <tbody class="em-no-table-row-hover">
      <ng-container *ngFor="let dataset of datasetTable.data; trackBy: trackByRef">
        <tr>
          <td>{{ dataset.name }}</td>
          <td>
            <button nz-button (click)="onIconClick(dataset)">
              <img [src]="dataset.type" alt="icon displaying type of file" />
            </button>
          </td>
        </tr>
      </ng-container>
    </tbody>
  </nz-table>
</ng-template>
